<app-breadcrumb [labels]=breadcrumb fullBC="{{true}}"></app-breadcrumb>
<div class="card-details-container">
    <div class="card-details-wrapper flex-compliance">
        <div class="card-wrapper">
            <nz-card class="compliance-card help-card" [nzBordered]="false">
                <div class="details-card-wrapper">
                    <div class="title">Incivus</div>
                    <div class="description">
                            <div class="secBody">
                                <div >
                                    Incivus is where creativity meets artificial intelligence. We augment creativity with cutting-edge
                                    technologies like computer vision, audition, NLP, and more to evaluate ads against realistic, AI-driven
                                    criteria.
                                    We provide a precise, objective, and granular evaluation of all creative variables of an ad. Each creative
                                    is evaluated to gauge its impact against campaign goals and business needs. 
                                </div>
                            </div>
                    </div>
                </div>

                <div class="details-card-wrapper">
                    <div class="title" style="margin-top: 1rem">Put AI at the Heart of Evaluating Ads</div>
                    <div class="description">
                            <div class="secBody">
                                <div >
                                    Quantify and iterate your ad creatives with the help of our proprietary recall score, attention graphs,and other creative effectiveness measures.
                                    <ul>
                                        <li>Finding why an ad works or not at a creative element level</li>
                                        <li>Easily scale AI-based testing, no panel required</li>
                                        <li>Potentially save up to 15% of ad spend</li>
                                        <li>Eventually elimination of A/B tests</li>
                                        <li>Ensure brand consistency across geographies and ad types</li>
                                        <li>Launch campaigns faster</li>
                                        <li>Understand what makes an ad memorable</li>
                                    </ul>
                                </div>
                        </div>
                    </div>
                </div>


                <div class="details-card-wrapper">
                    <div class="title" style="margin-top: 1rem">The Current Challenges with Ad Evaluation</div>
                    <div class="description">
                            <div class="secBody">
                                <div >
                                    <p>
                                    Brands invest highly in terms of time and resources to test their concepts and creatives before launching
                                    their ad campaigns. While concept and creative testing provides a level of assurance to the marketers,
                                    there are many shortcomings to the current methods of testing that include surveys and focus groups.
                                    </p>
                                    <p>
                                    User: Growth Marketer, Performance Marketer, Creative Director.
                                    </p>
                                    
                                    Challenges:     
                                                                  
                                    <ul>
                                        <li>Failing to pinpoint why behind success of failure of campaign</li>
                                        <li>Limited sample size in surveys and focus groups</li>
                                        <li>Intensive investment of time and cost</li>
                                        <li>Subjective judgments and uninformed opinions of people</li>
                                        <li>Ad blindness</li>
                                        <li>Lack of context</li>
                                        <li>Controlled environment which doesn't reflect the real world</li>
                                        <li>Scalability of current ad testing methods</li>
                                        <li>Bias, comparison, and information processing fatigue</li>
                                    </ul>
                                </div>
                        </div>
                    </div>
                </div>

                <div class="details-card-wrapper">
                    <div class="title" style="margin-top: 1rem">Use Incivus to take data-driven, unbiased creative decisions</div>
                    <div class="description">
                            <div class="secBody">
                                <div >
                                    Incivu's AI-engine has been trained on millions of data points in the past two years to provide users with
                                    precise, granular, and unbiased evaluation of impact of creative elements on the overall success of
                                    campaigns.                                    
                                    <ul>
                                        <li><b>Creative Effectiveness score: </b>This is a comprehensive score made with recall, cognitive load and
                                            ad copy effectiveness score. This score determines the engagement and the effectiveness of the
                                            Ad to meet your marketing objectives.</li>
                                        <li><b>Recall: </b> Identify the most and least recognizable and memorable frames of your video ads. For
                                            display ads, get the overall recall score of your ad to understand its impact on viewer’s memory.</li>
                                        <li><b>Cognitive load: </b>  When consumers are exposed to an overwhelming amount of information, it
                                            can lead to cognitive overload, hindering their ability to make informed decisions. The paralyzing
                                            effect of choice overload, a phenomenon where consumers struggle to decide when presented
                                            with too many options, is a testament to this effect. According to a 2023 Journal of Consumer
                                            Research study, choice overload led to a 27% decrease in consumer satisfaction and a 35%
                                            decrease in the likelihood of repeat purchases.</li>
                                        <li><b>Brand Compliance: </b>Check if your video and display ads are compliant with your brand guidelines
                                            or not. Our AI checks brand elements, colors, product visuals, brand recognition, tone of voice
                                            and more.</li>
                                        <li><b>Attention: </b> Identifies where the attention is falling and at what intensity. For video ads, it also
                                            identifies keyframes with the highest concentration of attention.</li>
                                        <li><b>Ad Copy effectiveness: </b> Measure the effectiveness of your ad copy. Our AI evaluates word
                                            density, tone, speaking density, languages, and more.</li>
                                        <li><b>Emotions: </b>Identify the emotions invoked by color, human face, music and text.</li>
                                        <li><b>Music: </b>A feature exclusive to video ads, our AI engine dissects the music of your video ads to
                                            give an overview of the genre, mood, and emotions evoked by the music.</li>
                                            <li><b>Digital accessibility: </b>Accessibility, also known as inclusive or universal design, makes websites
                                                and digital communications usable for everyone, including those who have a short- or long-term
                                                disability. We analyze the ads for vision (colors) and hearing (sound-off) accessibility.</li>
                                    </ul>
                                </div>
                        </div>
                    </div>
                </div>
                <div class="title">Supported Creatives</div>
                        <br>
                            <div class="secBody">
                            <div class="helpSec">
                                <table>
                                    <tr>
                                        <td class="table-data">Supported image files</td>
                                        <td class="table-data">.jpg , .jpeg, .png</td>
                                    </tr>
                                    <tr>
                                        <td class="table-data">Supported video files</td>
                                        <td class="table-data">.mp4, .avi, .wmv, .ogg, .webm, .mov</td>
                                    </tr>
                                    <tr>
                                        <td class="table-data">Max. number of Video Ad files to be uploaded at one time</td>
                                        <td class="table-data">1 file at a time</td>
                                    </tr>
                                    <tr>
                                        <td class="table-data">Max. number of Video Ads that can be analyzed</td>
                                        <td class="table-data">Configured as part of account setup</td>
                                    </tr>
                                    <tr>
                                        <td class="table-data">Max. number of Display Ad (Image) files to be uploaded at one time</td>
                                        <td class="table-data">There is no max limit but it is advisable to upload 2 files at a time</td>
                                    </tr>
                                    <tr>
                                        <td class="table-data">Max. number of Display Ads (Image) that can be analyzed</td>
                                        <td class="table-data">Configured as part of account setup</td>
                                    </tr>
                                    <tr>
                                        <td class="table-data">Max. file size for Video Ads</td>
                                        <td class="table-data">500 MB</td>
                                    </tr>
                                    <tr>
                                        <td class="table-data">Max. file size for Display Ads (Images)</td>
                                        <td class="table-data">20 MB</td>
                                    </tr>
                                    <tr>
                                        <td class="table-data">Min. width and Height</td>
                                        <td class="table-data">Images : 250X250px | Videos: 1200X1200px</td>
                                    </tr>
                                    <tr>
                                        <td class="table-data">Video Ad length</td>
                                        <td class="table-data">Between 15 seconds to 1.5 minutes</td>
                                    </tr>
                                    <tr>
                                        <td class="table-data">Video frame rate</td>
                                        <td class="table-data">2 fps</td>
                                    </tr>
                                    <tr>
                                        <td class="table-data">Filename specifications</td>
                                        <td class="table-data">Avoid special characters, including language specific characters in filenames.</td>
                                    </tr>
                                </table>
                            </div>
                        </div>
            </nz-card>
        </div>
    </div>
</div>